//*Detalle del articulo y/o producto que que se desea adquirir *//
//===================================
// PDP / Detalle del articulos / productos

import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import { mappersPDP } from "@/Mappers/products.mapper";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import type { products } from "@/Models/MProduct/Products";
import { useEffect, useState } from "react";
import { getIpCliente } from "../Index";
import type { BasketResponse } from "@/Models/Response/BasketResponse";

export const useViewInfoProduct = (
  sku: string,
  category: string,
  subCategory: string
) => {
  //Data Product
  const [mDatos, setMDatos] = useState<ProductByIdPdp[]>([]);
  //Loadding por Skeleton
  const [isLoading, setIsLoading] = useState<boolean>(true);
  //hacemos la consulta hacia le back
  const { data: productosInfo, loading: isLoadings } = useFunctionInfo<
    products[] | BasketResponse
  >(`/VerCategorias?sku=${sku}`);

  const isResponseStatus = (data: any): data is BasketResponse => {
    return (
      data &&
      typeof data === "object" &&
      "status" in data &&
      typeof data.status === "number" &&
      "message" in data &&
      typeof data.message === "string"
    );
  };

  const isProductsArray = (data: any): data is products[] => {
    return (
      Array.isArray(data) &&
      data.length > 0 &&
      typeof data[0] === "object" &&
      "Id" in data[0] //&&
      //"Name" in data[0]
    );
  };

  useEffect(() => {
    setIsLoading(true);
    // solo ejecutamos el setTimeout si ya se cargaron los datos.
    if (!isLoadings && productosInfo) {
      if (isResponseStatus(productosInfo)) {
        setMDatos([]);
        setIsLoading(false);
      }

      if (isProductsArray(productosInfo)) {
        const timers = setTimeout(async () => {
          const ipClient = await getIpCliente();
          //data mapping for products
          const resultMapper = await mappersPDP(
            productosInfo,
            category,
            subCategory!,
            String(ipClient)
          );
          setMDatos(resultMapper);
          //loading
          setIsLoading(false);
        }, 200);

        return () => clearTimeout(timers);
      }
    }
  }, [productosInfo, isLoadings]);

  return {
    mDatos,
    isLoading,
  };
};

export const useAddToCardBuy = () => {
  const { postData } = useFunctionInfo<any>("");
  const buyCardSku = "/Carrito";
  return {
    postData,
    buyCardSku,
  };
};

export const useProductSku = (sku: string) => {
  //Data Product
  const [productsData, setProductsData] = useState<products[]>([]);
  //hacemos la consulta hacia le back
  const { data: productosInfo, loading: isLoadings } = useFunctionInfo<
    products[]
  >(`/VerCategorias?sku=${sku}`);

  useEffect(() => {
    const productInfo = Array.isArray(productosInfo) ? productosInfo.length : 0;
    const productInfoData = Array.isArray(productosInfo) ? productosInfo : [];

    // solo ejecutamos el setTimeout si ya se cargaron los datos.
    if (!isLoadings && productInfo > 0) {
      const timers = setTimeout(async () => {
        setProductsData(productInfoData);
      }, 2000);

      return () => clearTimeout(timers);
    }
  }, [productosInfo, isLoadings]);

  return {
    productsData,
    isLoadings,
  };
};
